import React, { useState, useEffect } from "react";
import "./SelectedSession.css";
import TranscriptView from "../selectedSessionComponent/TranscriptView";
import { TabHeader } from "../selectedSessionComponent/TabHeader";
import { CircularProgress } from "@mui/material";
import LoadingScreen from "../selectedSessionComponent/NoSummary";
import useUserStore from "../../store/useUserStore";
import { ArrowLeft, FileText, SortAsc } from "lucide-react";
import SurgicalNotes from "../selectedSurgicalComponent/SurgicalNotes";
import FeedbackModal from "../selectedSessionComponent/FeedbackModal";
import useSurgicalStore from "../../store/useSurgicalStore";

export default function SelectedSurgicalSession() {
  const [activeTab, setActiveTab] = useState("transcript");
  const [letterType, setLetterType] = useState(null);
  const { activePage, isMobile, setActivePage } = useUserStore();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    currentSession,
    transcript,
    audio_url,
    surgicalNote,
    surgicalId,
    setTranscriptData,
    getSurgicalDetail,
    loading,
    setLoading,
  } = useSurgicalStore();
  const [showPopUp, setShowPopUp] = useState(false);


  useEffect(() => {
    setActiveTab("transcript");
  }, [surgicalId]);

  const handleFeedbackSave = (feedback) => {
    console.log('Feedback received:', feedback);
    setIsModalOpen(false); // Close the modal after saving
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };


  const renderActiveComponent = () => {
    switch (activeTab) {
      case "transcript":
        return (
          <TranscriptView
            audioUrl={audio_url}
            transcript={transcript}
            consultationId={surgicalId}
            isSurgical={true}
          />
        );
      case "surgical":
        return (
          <SurgicalNotes surgicalNote={surgicalNote}/>
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={`selected-session ${
        isMobile
          ? activePage === "selected-surgical-session"
            ? "selected-session-mobile"
            : "selected-session-hidden-mobile"
          : " "
      }`}
    >
      {/* Header Section */}
      <div className="header">
        <div className="arrow-wrapper">
          {isMobile && (
            <button
              className="arrow-btn"
              onClick={() => setActivePage("sidebar")}
            >
              <ArrowLeft />
            </button>
          )}
          <h1 className="page-title">Patient Details</h1>
        </div>
        <div className="feedback-wrapper">
          <h2 className="patient-name">{currentSession?.patient_name}</h2>
          <button onClick={() => setIsModalOpen(true)} className="feedback-btn">
            <FileText size={18} />
            Give Feedback
          </button>
        </div>
      </div>

      <div className="tab-section">
        <TabHeader
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          letterType={letterType}
          isSurgical={true}
        />
      </div>

      <div className="summary-transcript-view">
        {loading ? (
          <CircularProgress
            size={60}
            sx={{ position: "relative", top: "35%", left: "40%" }}
          />
        ) : transcript || surgicalNote ? (
          <>{renderActiveComponent()}</>
        ) : (
          <LoadingScreen message={"Transcript and Surgical Note"}/>
        )}
      </div>

      {isModalOpen && (
        <FeedbackModal onClose={handleModalClose} onSave={handleFeedbackSave} isSurgical={true} />
      )}
      
    </div>
  );
}
